export default {"src":"/_next/static/media/icon-smart-targeting.35a3f675.svg","height":141,"width":140,"blurWidth":0,"blurHeight":0};